import { ErrorHandler } from '@angular/core';
import { environment } from '@environment';

export class ErrorLogger implements ErrorHandler {

    static initWith(sentry: any) {
        return () => new ErrorLogger(sentry);
    }


    excludeErrorMessages: any = ['t[l].resolve is not a function', 'ChunkLoadError', 'object unsubscribed', 'Network Error', 'getReadModeExtract', 'getReadModeRender', 'getReadModeConfig', 'Timeout', 'ResizeObserver'];

    constructor(private sentry: any) {

        const self = this;

        if (environment.NODE_ENV === 'production') {
            this.sentry.init({
                dsn: environment.sentryDsn,
                release: environment.VERSION,
                environment: environment.NODE_ENV,
                beforeSend(event, hint) {

                    try {

                        let isNonErrorException;

                         /* tslint:disable:no-string-literal only-arrow-functions */
                        isNonErrorException =
                            event.exception.values[0].value.startsWith('Non-Error exception captured') ||
                            (hint.originalException && hint.originalException['message'].startsWith('Non-Error exception captured'));

                        /* tslint:enable:no-string-literal only-arrow-functions */

                        if (isNonErrorException) {
                            return null;
                        }

                        /* tslint:disable:no-string-literal only-arrow-functions */

                        isNonErrorException = self.excludeErrorMessages.reduce((isNonError, currentString) => {
                            return (event.exception.values[0].value.includes(currentString) || (hint.originalException && hint.originalException['message'].includes(currentString) || isNonError));
                        }, false);

                        /* tslint:enable:no-string-literal only-arrow-functions */

                        if (isNonErrorException) {
                            // We want to ignore those kind of errors
                            return null;
                        }
                    } catch(e) {
                        console.log(e);
                        return event;
                    }

                    return event;
                }
            });
        }
    }

    handleError(error: any): void {
        if (environment.NODE_ENV === 'production') {
            this.sentry.captureException(error.originalError || error);
            if (typeof window !== "undefined") {
                if ((<any>window).newrelic) {
                    (<any>window).newrelic.noticeError(error.originalError || error);
                }
            }
        }
        else {
            throw error;
        }
    }
}
